<div
  class="w-full template-renderer-wrapper"
  [innerHTML]="safeRenderedHtml()"
></div>
